module.exports = __webpack_public_path__ + "static/img/pro10_tab1.193f969.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro10_tab1.jpg
// module id = ZgOP
// module chunks = 171